var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.valueBackup)?_c('div',{staticClass:"qr-code-box",on:{"click":_vm.hideQrcode}},[_c('v-img',{staticClass:"qr-code",attrs:{"value":_vm.valueBackup}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }